import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element, NavigationParent } from 'common/types/tracking';

const enum NavigationEvent {
  GlobalHeaderClick = 'global-header_click',
  ShopInShopNavClick = 'shop-in-shop-navigation_click',
}

const enum Placement {
  Toolbar = 'toolbar',
  MyAccountTooltip = 'my-account-tooltip',
}

export const trackLogoClick = (
  parentComponent = NavigationParent.GlobalHeader,
  shopName?: string
) => {
  dispatchTrackingEventGA4({
    event:
      parentComponent === NavigationParent.ShopInShopNav
        ? NavigationEvent.ShopInShopNavClick
        : NavigationEvent.GlobalHeaderClick,
    element: Element.Image,
    label: 'brand-logo',
    placement: Placement.Toolbar,
    ...(shopName && { shop_name: shopName }),
  });
};

export const trackHamburgerClick = (parentComponent = NavigationParent.GlobalHeader) => {
  dispatchTrackingEventGA4({
    event:
      parentComponent === NavigationParent.ShopInShopNav
        ? NavigationEvent.ShopInShopNavClick
        : NavigationEvent.GlobalHeaderClick,
    element: Element.Button,
    label: 'hamburger-button',
    placement: Placement.Toolbar,
  });
};

export const trackActionItemClick = (label: string) => {
  dispatchTrackingEventGA4({
    event: NavigationEvent.GlobalHeaderClick,
    element: Element.Icon,
    label,
    placement: Placement.Toolbar,
  });
};

export const trackMyAccountTooltipClick = (label: string, element = Element.Link) => {
  dispatchTrackingEventGA4({
    event: NavigationEvent.GlobalHeaderClick,
    element,
    clicked_text: label,
    placement: Placement.MyAccountTooltip,
  });
};

export const trackLanguageSelectorClick = (language: string) => {
  // Capitalize first letter (as displayed to user)
  const clicked_text = language.charAt(0).toUpperCase() + language.slice(1);
  dispatchTrackingEventGA4({
    event: NavigationEvent.GlobalHeaderClick,
    element: Element.Link,
    clicked_text,
    placement: Placement.Toolbar,
  });
};

export const trackZipCodeClick = (label: string) => {
  dispatchTrackingEventGA4({
    event: NavigationEvent.GlobalHeaderClick,
    element: Element.Button,
    clicked_text: label,
    placement: Placement.Toolbar,
  });
};
